import type { CircleLayout, CirclePaint } from 'mapbox-gl';
import { RiskLevelEnum, type RegionalOverviewSource } from 'querys/regional-overview/regional-overview.query.models';
import { RegionalRiskLevelColor } from '../regional-risk.models';

export function getRiskColor(): CirclePaint['circle-color'] {
  return [
    'match',
    ['get', 'calculatedRisk'],
    RiskLevelEnum.MISSING_CONFIG,
    RegionalRiskLevelColor.MISSING_CONFIG,
    RiskLevelEnum.NO_RISK,
    RegionalRiskLevelColor.NO_RISK,
    RiskLevelEnum.LOW,
    RegionalRiskLevelColor.LOW_RISK,
    RiskLevelEnum.MEDIUM,
    RegionalRiskLevelColor.MEDIUM_RISK,
    RiskLevelEnum.HIGH,
    RegionalRiskLevelColor.HIGH_RISK,
    /* other */ 'transparent'
  ];
}

export function getRiskOrder(): CircleLayout['circle-sort-key'] {
  return [
    'match',
    ['get', 'calculatedRisk'],
    RiskLevelEnum.MISSING_CONFIG,
    -2,
    RiskLevelEnum.NO_RISK,
    -1,
    RiskLevelEnum.LOW,
    RiskLevelEnum.LOW,
    RiskLevelEnum.MEDIUM,
    RiskLevelEnum.MEDIUM,
    RiskLevelEnum.HIGH,
    RiskLevelEnum.HIGH,
    /* other */ -2
  ];
}

export const isModelEnabled = (currentModel: RegionalOverviewSource, model: RegionalOverviewSource): boolean => currentModel === model;
